/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Access_PendingInputs */

const en_document_access_pending = /** @type {(inputs: Document_Access_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending Approval`)
};

const id_document_access_pending = /** @type {(inputs: Document_Access_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menunggu Persetujuan`)
};

/** @type {(inputs: Document_Access_PendingInputs) => LocalizedString} */
const es_document_access_pending = en_document_access_pending;

/** @type {(inputs: Document_Access_PendingInputs) => LocalizedString} */
const fr_document_access_pending = en_document_access_pending;

/** @type {(inputs: Document_Access_PendingInputs) => LocalizedString} */
const de_document_access_pending = en_document_access_pending;

/** @type {(inputs: Document_Access_PendingInputs) => LocalizedString} */
const ja_document_access_pending = en_document_access_pending;

/** @type {(inputs: Document_Access_PendingInputs) => LocalizedString} */
const zh_document_access_pending = en_document_access_pending;

/** @type {(inputs: Document_Access_PendingInputs) => LocalizedString} */
const ar_document_access_pending = en_document_access_pending;

/** @type {(inputs: Document_Access_PendingInputs) => LocalizedString} */
const it_document_access_pending = en_document_access_pending;

/** @type {(inputs: Document_Access_PendingInputs) => LocalizedString} */
const ru_document_access_pending = en_document_access_pending;

/** @type {(inputs: Document_Access_PendingInputs) => LocalizedString} */
const pt_document_access_pending = en_document_access_pending;

/** @type {(inputs: Document_Access_PendingInputs) => LocalizedString} */
const ko_document_access_pending = en_document_access_pending;

/**
* | output |
* | --- |
* | "Pending Approval" |
*
* @param {Document_Access_PendingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_access_pending = /** @type {((inputs?: Document_Access_PendingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Access_PendingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_access_pending(inputs)
	if (locale === "es") return es_document_access_pending(inputs)
	if (locale === "fr") return fr_document_access_pending(inputs)
	if (locale === "de") return de_document_access_pending(inputs)
	if (locale === "ja") return ja_document_access_pending(inputs)
	if (locale === "zh") return zh_document_access_pending(inputs)
	if (locale === "ar") return ar_document_access_pending(inputs)
	if (locale === "id") return id_document_access_pending(inputs)
	if (locale === "it") return it_document_access_pending(inputs)
	if (locale === "ru") return ru_document_access_pending(inputs)
	if (locale === "pt") return pt_document_access_pending(inputs)
	return ko_document_access_pending(inputs)
});